import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class Fps {

  #rmp;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  static #stringToArray(string) {
    const buffer = new ArrayBuffer(string.length * 2); // 2 bytes for each char
    const array = new Uint16Array(buffer);
    for (let i = 0, strLen = string.length; i < strLen; i++) {
      array[i] = string.charCodeAt(i);
    }
    return array;
  }

  static #concatInitDataIdAndCertificate(initData, id, cert) {
    if (typeof id === 'string') {
      id = Fps.#stringToArray(id);
    }
    // layout is [initData][4 byte: idLength][idLength byte: id][4 byte:certLength][certLength byte: cert]
    let offset = 0;
    const buffer = new ArrayBuffer(initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength);
    const dataView = new DataView(buffer);

    const initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
    initDataArray.set(initData);
    offset += initData.byteLength;

    dataView.setUint32(offset, id.byteLength, true);
    offset += 4;

    const idArray = new Uint16Array(buffer, offset, id.length);
    idArray.set(id);
    offset += idArray.byteLength;

    dataView.setUint32(offset, cert.byteLength, true);
    offset += 4;

    const certArray = new Uint8Array(buffer, offset, cert.byteLength);
    certArray.set(cert);

    return new Uint8Array(buffer, 0, buffer.byteLength);
  }

  static #setXMLHttpRequestHeaders(request, headers) {
    headers.forEach(header => {
      if (typeof header.name === 'string' && typeof header.value === 'string') {
        Logger.print('fps', 'adding license header ' + header.name + ':' + header.value);
        request.setRequestHeader(header.name, header.value);
      }
    });
  }

  #licenseRequestReady(event) {
    Logger.print('fps', 'webkitkeymessage', event);
    const session = event.target;
    const message = event.message;
    const request = new XMLHttpRequest();
    //let sessionId = event.sessionId;
    request.responseType = this.#rmp.fpsDrm.licenseResponseType;
    request.session = session;
    request.addEventListener('load', this.#rmp.fpsDrm.licenseRequestLoaded.bind(this.#rmp), { once: true });
    request.addEventListener('error', event => {
      this.#rmp.rmpUtils.error(604, event);
    }, { once: true });
    const params = this.#rmp.fpsDrm.licenseRequestMessage(message, session);
    request.open('POST', this.#rmp.fpsDrm.processSpcPath, true);
    Fps.#setXMLHttpRequestHeaders(request, this.#rmp.fpsDrm.licenseRequestHeaders);
    Logger.print('fps', 'sending license request with following params', params);
    request.send(params);
  }

  #onNeedKey(certificate, event) {
    Logger.print('fps', 'webkitneedkey event');
    let initData = event.initData;
    Logger.print('fps', 'onneedkey event follows', event);
    const contentId = this.#rmp.fpsDrm.extractContentId(initData);
    initData = Fps.#concatInitDataIdAndCertificate(initData, contentId, certificate);
    Logger.print('fps', 'initData follows', initData);

    if (!this.#rmp.dom.video.webkitKeys) {
      let keySystem = 'com.apple.fps.1_0';
      if (typeof this.#rmp.fpsDrm.keySystem === 'string' && this.#rmp.fpsDrm.keySystem !== '') {
        keySystem = this.#rmp.fpsDrm.keySystem;
      }
      if (!WebKitMediaKeys.isTypeSupported(keySystem, 'video/mp4')) {
        this.#rmp.rmpUtils.error(601);
        return;
      }
      this.#rmp.dom.video.webkitSetMediaKeys(new WebKitMediaKeys(keySystem));
    }

    if (!this.#rmp.dom.video.webkitKeys) {
      this.#rmp.rmpUtils.error(602);
      return;
    }

    const keySession = this.#rmp.dom.video.webkitKeys.createSession('video/mp4', initData);
    if (!keySession) {
      this.#rmp.rmpUtils.error(603);
      return;
    }

    keySession.contentId = contentId;
    Logger.print('fps', 'contentId set on keySession', contentId);
    FW.waitForEvent('webkitkeymessage', this.#licenseRequestReady.bind(this), keySession);
    FW.waitForEvent('webkitkeyadded', event => {
      Logger.print('fps', 'decryption key was added to session', event);
    }, keySession);
    FW.waitForEvent('webkitkeyerror', event => {
      this.#rmp.rmpUtils.warning(6000, event);
    }, keySession);
    Logger.print('fps', 'keySession follows', keySession);
  }

  init() {
    Logger.print('fps', 'start loadCertificate - FPS input config follows:', this.#rmp.fpsDrm);

    const request = new XMLHttpRequest();
    request.responseType = 'arraybuffer';

    request.addEventListener('load', event => {
      const request = event.target;
      let certificate;
      if (typeof this.#rmp.fpsDrm.prepareCertificate === 'function') {
        certificate = this.#rmp.fpsDrm.prepareCertificate(request.response);
      } else {
        certificate = new Uint8Array(request.response);
      }
      Logger.print('fps', 'certificate loaded', certificate);
      this.#rmp.dom.video.addEventListener('webkitneedkey', this.#onNeedKey.bind(this, certificate));
      this.#rmp.dom.video.addEventListener('error', event => {
        this.#rmp.rmpUtils.warning(6001, event);
      });
      this.#rmp.dom.video.src = this.#rmp.startingSrcUri;
    }, { once: true });

    request.addEventListener('error', event => {
      this.#rmp.rmpUtils.error(600, event);
    }, { once: true });

    request.open('GET', this.#rmp.fpsDrm.certificatePath, true);

    Fps.#setXMLHttpRequestHeaders(request, this.#rmp.fpsDrm.certificateRequestHeaders);

    Logger.print('fps', 'sending FPS certificate request at ' + this.#rmp.fpsDrm.certificatePath);
    request.send();
  }
}
